module.exports = __webpack_public_path__ + "static/media/nn-Nonord-C-Y-A-trial-distractio.81a2a83d.mp3";